// extracted by mini-css-extract-plugin
module.exports = {"couter":"InstancesCounter__couter--B8","runningCount":"InstancesCounter__runningCount--Ja"};